/* =============================================================
   Plek in Bloei — navigatie
   Mobiel menu, meescrollende kop, aankondigingen, sfeervideo.
   ============================================================= */

(function (PIB) {
  'use strict';

  /* ---- mobiel menu ---- */

  PIB.register('mobiel-menu', function (root) {
    root.querySelectorAll('[data-menu-knop]').forEach(function (knop) {
      if (!PIB.eenmalig(knop, 'menuGebonden')) return;

      var paneel = document.getElementById(knop.getAttribute('aria-controls'));
      if (!paneel) return;

      function zet(open) {
        knop.setAttribute('aria-expanded', String(open));
        paneel.hidden = !open;
      }

      knop.addEventListener('click', function () {
        zet(knop.getAttribute('aria-expanded') !== 'true');
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !paneel.hidden) { zet(false); knop.focus(); }
      });
    });
  });

  /* ---- kop die terugkomt bij omhoog scrollen ---- */

  PIB.register('kop', function (root) {
    var header = root.querySelector('.header--transparant');
    if (!header || !PIB.eenmalig(header, 'kopGebonden')) return;

    var vorige = window.scrollY;
    var drempel = 200;

    window.addEventListener('scroll', function () {
      var nu = window.scrollY;
      if (nu > drempel && nu < vorige) header.classList.add('is-vast');
      else if (nu <= drempel || nu > vorige) header.classList.remove('is-vast');
      vorige = nu;
    }, { passive: true });
  });

  /* ---- aankondigingen laten rouleren ---- */

  PIB.register('aankondiging', function (root) {
    root.querySelectorAll('[data-rouleren]').forEach(function (spoor) {
      if (!PIB.eenmalig(spoor, 'rouleert')) return;

      var regels = spoor.querySelectorAll('p');
      if (regels.length < 2 || PIB.kalm) return;

      var i = 0;
      var tempo = parseInt(spoor.dataset.rouleren, 10) || 6000;

      setInterval(function () {
        regels[i].hidden = true;
        i = (i + 1) % regels.length;
        regels[i].hidden = false;
      }, tempo);
    });
  });

  /* ---- sfeervideo: pas laden als hij in beeld komt ---- */

  PIB.register('sfeervideo', function (root) {
    var videos = root.querySelectorAll('video[data-sfeer]');
    if (!videos.length) return;

    var klein = window.matchMedia('(max-width: 749px)').matches;

    videos.forEach(function (video) {
      if (!PIB.eenmalig(video, 'sfeerGebonden')) return;

      video.muted = true;
      video.setAttribute('playsinline', '');

      var bron = klein ? (video.dataset.bronMobiel || video.dataset.bron) : video.dataset.bron;
      if (bron && !video.src) { video.src = bron; video.load(); }

      if (PIB.kalm) { video.pause(); return; }

      if (!('IntersectionObserver' in window)) { video.play().catch(function () {}); return; }

      new IntersectionObserver(function (regels) {
        regels.forEach(function (regel) {
          if (regel.isIntersecting) video.play().catch(function () {});
          else video.pause();
        });
      }, { threshold: 0.15 }).observe(video);
    });

    root.querySelectorAll('[data-video-schakelaar]').forEach(function (knop) {
      if (!PIB.eenmalig(knop, 'schakelGebonden')) return;

      var video = document.getElementById(knop.getAttribute('aria-controls'));
      if (!video) return;

      knop.addEventListener('click', function () {
        if (video.paused) { video.play().catch(function () {}); knop.setAttribute('aria-pressed', 'true'); }
        else { video.pause(); knop.setAttribute('aria-pressed', 'false'); }
      });
    });
  });

  /* ---- lopende band verdubbelen als de sectie te kort is ---- */

  PIB.register('loopband', function (root) {
    root.querySelectorAll('.loopband__spoor').forEach(function (spoor) {
      if (spoor.dataset.verdubbeld === 'ja') return;
      spoor.innerHTML += spoor.innerHTML;
      spoor.dataset.verdubbeld = 'ja';
    });
  });
})(window.PIB);
